<template>
<div class="container-fluid" >

 <div class="card border-success">

  
    <h4 class="card-header text-white bg-primary">
        
    <i style="color:yellow" class="fas fa-balance-scale mr-2" aria-hidden="true"></i>
    IMMESSO/VENDUTO PER MISURA</h4>
  

 <div  class="card-body"> 
  
   <div class="row">
   <div v-if="cols.length == 0" class="col"> 

  <div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-black">


  <form name="filter" v-on:submit.prevent="submit()">

    <div class="row">
     <div class="col-md-3">
      <season-select v-bind:props="season"  @update="setSeasonId"></season-select>  
     </div>
     <div class="col-md-3">
      <year-select  v-bind:props="season_year" @update="setYear"></year-select>   
     </div>
        
    <div class="col-md-3">
      <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>
    </div>
  
    <div class="col-md-3">
      <supplier-brand-list :key="refresh"  v-bind:props="brand" @update="setBrandId"></supplier-brand-list>
    </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <department-select v-bind:props="department" @update="setDepartmentId"></department-select>  
      </div>  
      <div class="form-group">
        <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>
      </div>
    </div>   
<div class="card-footer bg-transparent border-info">
   <button :disabled="spinner" type="submit"  class="btn btn-primary float-right">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI
      <span style="color:yellow" v-if="spinner" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
     </button>           

    
</div>




  </form>
</div>
</div>
<alert-box style="margin-top:10px" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
</div>



<!--COL 2 -->
<div v-else class="col">
 
<button @click="cols=[]" type="button"   class="btn btn-secondary mt-1 mb-1">

<i style="color:yellow" class="fas fa-reply mr-2"></i>
RITORNA A PARAMETRI RICERCA      
</button> 

    


 <div class="table-responsive">    
 <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table id='my-table' class="table table table-sm table-hover table-bordered table-striped mb-0">
    <thead >
      <tr class="table-primary">
       
        <th class="text-nowrap" v-for="(col,index) in cols" :key="index">
            <span>{{col}}</span>
       </th>           
        
        
           
      </tr>
    </thead>
    <tbody>
      <tr :style="{backgroundColor : item.category  ? '' : '#ccffee'}" v-for="(item, index) in items" :key="index">
      
                
        <td class="text-nowrap" v-for="(col,index1) in cols" :key="index1">
            <span>{{item[col]}}</span>
            
        </td>    
       
      </tr> 
    </tbody>

    
  </table>

</div>
 </div> 


 


</div>  

</div>
 </div>
 </div>

<!--
<button :disabled="items.length==0 " @click="exportToCSV()" type="button"   class="btn btn-success mt-2 mb-3 float-right mr-2">

<i class="fas fa-file-export mr-2"></i>
      ESPORTA CSV
      <span v-if="1==0" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>  
-->




</div>


</template>
<script>
import api             from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';



import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
import supplierBrandList from '@/components/common/SupplierBrandSelect_1.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'
import categoryGrouping  from '@/components/common/CategoryGroupingSelect_1.vue'
//import 'jspdf-autotable'
//import autoTable from 'jspdf-autotable'

export default {

  components: {alertBox,seasonSelect,yearSelect,supplierSelect,supplierBrandList,departmentSelect,categoryGrouping},
  data() {
    return {
      
      supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : true

      },
      brand           :
      {
        supplierId    : 0,
        Id            : '%',
        required      : false,
        allBrands     : true

      },  
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
       
      },
      catGrouping     : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },

      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        type          : true


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : false

      },
      
  
      alert           : false, 
      spinner         : false,
    
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      cols            : [],
      refresh         : 100
      
     
      
      
    }
  },

  computed :{
    ...mapGetters(['company']),
    
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    //this.getGrouping()
  },
  methods: {
    exportToCSV()
    {},
    setDepartmentId(departmentId,e)
    {
      this.department.Id        = departmentId
      //this.pdf_title.department = e.target.options[e.target.options.selectedIndex].text
    },
    setSupplierId(supplierId,text)
    {  
     
      this.supplier.Id = supplierId
      //this.pdf_title.supplier = text  
      this.brand.supplierId = supplierId
      this.refresh++
      
    },  
      setBrandId(brandId)
      {
        this.brand.Id = brandId
      },
      
    setGroupCategoryId(Id,e)
    {
      
  
      this.catGrouping.Id = Id
      
    
    },
    setSeasonId(seasonId)
    {           
      this.season.Id        = seasonId
      
    },      
    setYear(year)
    {
      this.season_year.year = year
      
      
      

    },     

  
   
    
    submit() 
    {
     this.getData()
    },  
    
  
    async getData() {
      
  
      this.items = []
      this.cols = []
      
      
      this.msg.title = ''
      
      const sp = {'sp' : 'spSellOutOnSize'} 
      const data  = {

          'companyId':this.company.Id,
          'seasonId':this.season.Id,
          'season_year':this.season_year.year,
          'supplierId':this.supplier.Id,'brand':this.brand.Id,
          'departmentId': this.department.Id,
          'catGroupId' : this.catGrouping.Id

          
      }
      console.log(data)
      const json  = Object.assign(data, sp)
      this.spinner = true


      await api.post(json).then(res => {
         
          if(res.status==200)
            {   
                this.items = res.data.recordsets[0]

                
                if(this.items.length > 0)
                {
                   
                    const sizes = res.data.recordsets[1][0].sizes.split('|')
                    this.cols = sizes              

                   

                   

                }    
                              
            if(this.items.length==0)
              {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      


    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 800px;
overflow   : auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : darkgreen;
    color        : white;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    

 }

.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
</style>